import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import { Grid, LinearProgress } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import slide1 from "../assets/img/slide/BackImage.png";
import axios from "axios";
import { useDispatch, connect } from "react-redux";
import { setUserCredentials } from "../redux/actions/appSettingsActions";
import CryptoJS from "crypto-js";
import { useTranslation } from "react-i18next";
import { appConifg } from "../config/default";
import LoginBtn from "../assets/img/UAEPass_LoginButton_Green.png";
import LoginBtn_AR from "../assets/img/AR_UAEPass_LoginButton_Green.png";
import LoginBtn_pressed from "../assets/img/UAEPass_LoginButton_Green_Pressed.png";
import LoginBtn_AR_pressed from "../assets/img/AR_UAEPass_LoginButton_Green_Pressed.png";
import { useCookies } from "react-cookie";
import ReactGA from "react-ga";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: "url(" + slide1 + ")",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const LoginPage = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  // const [isLogin, setIsLogin] = useState(
  //   props.settings.isLoggedIn == null
  // );
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [isRemember, setIsRemember] = useState(true);
  const [isPressed, setIsPressed] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation("loginPage");
  const [cookiesStore, setCookieStore] = useCookies(["store", "langauge"]);

  useEffect(() => {
    if (localStorage.getItem("RAK_ADDRESSING_userCreds")) {
      let bytes = CryptoJS.AES.decrypt(
        localStorage.getItem("RAK_ADDRESSING_userCreds"),
        "rakaddressing-secret-key@123"
      );
      let userCreds = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      setUsername(userCreds.username);
      setPassword(userCreds.password);
    }
  }, []);

  const handleLogin = () => {
    setShowAlert(false);
    setIsLoading(true);
    if (isRemember) {
      let data = { username: username, password: password };
      let cipherUsercreds = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        "rakaddressing-secret-key@123"
      ).toString();
      localStorage.setItem("RAK_ADDRESSING_userCreds", cipherUsercreds);
    } else {
      if (localStorage.getItem("RAK_ADDRESSING_userCreds"))
        localStorage.removeItem("RAK_ADDRESSING_userCreds");
    }
    let data = {};
    let axiosConfig = {
      headers: {
        username: username,
        password: password,
      },
    };
    axios
      .post(appConifg.Address.AddressApiUrl + "/Users/Login", data, axiosConfig)
      .then((response) => {
        setIsLoading(false);
        console.log(response);
        if (response.data?.isSucceeded) {
          dispatch(
            setUserCredentials({ data: response.data.data, flag: true })
          );
          ReactGA.event({
            category: "User",
            action: "Login",
          });
          history.push("/" + props.settings.activePage);
        } else {
          setAlertType("error");
          setAlertMsg(t("invalidMsg1"));
          setShowAlert(true);
        }
      })
      .catch((ex) => {
        setIsLoading(false);
        setAlertType("error");
        setAlertMsg(ex);

        setShowAlert(true);
      });
  };
  useEffect(() => {
    // setIsLogin(props.settings.userCredentials == null);

    setShowAlert(false);
  }, [props.settings.isLoggedIn]);

  const requestUaePass = () => {
    setIsPressed(true);
    if (props.addressingResult)
      setCookieStore("store", JSON.stringify(props.addressingResult), {
        path: "/",
      });
    setCookieStore("language", JSON.stringify(props.settings.language), {
      path: "/",
    });
    window.location.replace(
      appConifg.UaePassDetails.loginUrl +
        "?redirect_uri=" +
        appConifg.UaePassDetails.redirectUrl +
        "&client_id=" +
        appConifg.UaePassDetails.clientId +
        "&response_type=code&state=" +
        props.settings.activePage +
        "&scope=urn:uae:digitalid:profile:general&acr_values=urn:safelayer:tws:policies:authentication:level:low"
    );
  };

  const handleResetPassword = () => {
    setIsLoading(true);
    setShowAlert(false);
    let data = {
      UserName: props.settings.userCredentials.user.userName,
      OldPassword: currentPassword,
      NewPassword: newPassword,
    };
    let axiosConfig = {
      headers: {
        Authorization:
          "Bearer " + props.settings.userCredentials.token.access_token,
      },
    };
    if (newPassword !== confirmPassword) {
      setIsLoading(false);
      setAlertType("error");
      setAlertMsg(t("invalidMsg2"));
      setShowAlert(true);
      return;
    }
    axios
      .post(
        appConifg.Address.AddressApiUrl + "/Users/ResetExternalUserpassword",
        data,
        axiosConfig
      )
      .then((response) => {
        setIsLoading(false);
        if (response.data?.isSucceeded) {
          setAlertType("success");
          setAlertMsg(t("successMsg1"));
          setShowAlert(true);
        } else {
          setAlertType("error");
          setAlertMsg(response.data.status.message);
          setShowAlert(true);
        }
      })
      .catch((ex) => {
        setIsLoading(false);
        setAlertType("error");
        setAlertMsg(ex);
        setShowAlert(true);
      });
  };

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={6} md={8} className={classes.image} />
      {!props.settings.isLoggedIn ? (
        <Grid item xs={12} sm={6} md={4} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              {t("Signin")}
            </Typography>
            <br />
            <a href="javascript:void();">
              <img
                onClick={requestUaePass}
                src={
                  props.settings.language == "en"
                    ? isPressed
                      ? LoginBtn_pressed
                      : LoginBtn
                    : isPressed
                    ? LoginBtn_AR_pressed
                    : LoginBtn_AR
                }
                width="280"
                style={{ marginRight: "5px", marginTop: "-2px" }}
              />
            </a>
            <br />
            <Typography>{t("OrTag")}</Typography>
            <br />
            <form className={classes.form} noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                value={username}
                label={t("UserName")}
                onInput={(e) => setUsername(e.target.value)}
                name="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                value={password}
                onInput={(e) => setPassword(e.target.value)}
                name="password"
                label={t("Password")}
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    value="remember"
                    checked={isRemember}
                    color="primary"
                    onChange={() => setIsRemember(!isRemember)}
                  />
                }
                label={t("RememberMe")}
              />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={isLoading}
                className={classes.submit}
                onClick={handleLogin}
              >
                {t("Signin")}
              </Button>
              {/* Uncomment to enable UAE PASS */}
            </form>
          </div>
          {showAlert ? (
            <Alert severity={alertType}>
              <AlertTitle>
                {alertType === "success" ? "Success" : "Error"}
              </AlertTitle>
              {alertMsg}
            </Alert>
          ) : (
            ""
          )}
          {isLoading ? <LinearProgress /> : ""}
        </Grid>
      ) : (
        // <Grid item xs={12} sm={6} md={4} component={Paper} elevation={6} square>
        //   <div className={classes.paper}>
        //     <Avatar className={classes.avatar}>
        //       <LockOutlinedIcon />
        //     </Avatar>
        //     <Typography component="h1" variant="h5">
        //       Sign up
        //     </Typography>
        //     <form className={classes.form} noValidate>
        //       <Grid container spacing={2}>
        //         <Grid item xs={12} sm={6}>
        //           <TextField
        //             autoComplete="fname"
        //             name="firstName"
        //             variant="outlined"
        //             required
        //             fullWidth
        //             id="firstName"
        //             label="First Name"
        //             autoFocus
        //           />
        //         </Grid>
        //         <Grid item xs={12} sm={6}>
        //           <TextField
        //             variant="outlined"
        //             required
        //             fullWidth
        //             id="lastName"
        //             label="Last Name"
        //             name="lastName"
        //             autoComplete="lname"
        //           />
        //         </Grid>
        //         <Grid item xs={12}>
        //           <TextField
        //             variant="outlined"
        //             required
        //             fullWidth
        //             id="email"
        //             label="Email Address"
        //             name="email"
        //             autoComplete="email"
        //           />
        //         </Grid>
        //         <Grid item xs={12}>
        //           <TextField
        //             variant="outlined"
        //             required
        //             fullWidth
        //             name="password"
        //             label="Password"
        //             type="password"
        //             id="password"
        //             autoComplete="current-password"
        //           />
        //         </Grid>
        //         <Grid item xs={12}>
        //           <FormControlLabel
        //             control={
        //               <Checkbox value="allowExtraEmails" color="primary" />
        //             }
        //             label="I agree to T/C"
        //           />
        //         </Grid>
        //       </Grid>
        //       <Button
        //         type="submit"
        //         fullWidth
        //         variant="contained"
        //         color="primary"
        //         className={classes.submit}
        //       >
        //         Sign Up
        //       </Button>
        //       <Grid container justify="flex-end">
        //         <Grid item>
        //           <Link
        //             onClick={() => {
        //               setIsLogin(true);
        //             }}
        //             variant="body2"
        //           >
        //             Already have an account? Sign in
        //           </Link>
        //         </Grid>
        //       </Grid>
        //     </form>
        //   </div>
        // </Grid>
        <Grid item xs={12} sm={6} md={4} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              {t("ResetPwd")}
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                onInput={(e) => setCurrentPassword(e.target.value)}
                name="password"
                label={t("CurrentPwd")}
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                onInput={(e) => setNewPassword(e.target.value)}
                name="password"
                label={t("NewPwd")}
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                onInput={(e) => setConfirmPassword(e.target.value)}
                name="password"
                label={t("ConfirmNewPwd")}
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={isLoading}
                className={classes.submit}
                onClick={handleResetPassword}
              >
                {t("Reset")}
              </Button>
            </form>
          </div>
          {showAlert ? (
            <Alert severity={alertType}>
              <AlertTitle>
                {alertType === "success" ? "Success" : "Error"}
              </AlertTitle>
              {alertMsg}
            </Alert>
          ) : (
            ""
          )}
          {isLoading ? <LinearProgress /> : ""}
        </Grid>
      )}
    </Grid>
  );
};
const mapStateToProps = (state) => {
  return {
    settings: state.settings,
    addressingResult: state.addressingResult,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
